import { createSlice } from "@reduxjs/toolkit";

const initState = {
  user_Auth: {},
  user_Verify: {},
  template: {},
  current_TemplateID: null,
  // loader: false,
  template_Edit: false,
  edit_Template: false,
  create_Template: false,
  templateChanged: false,
  batchDownload: false,
  batchImages: false,
  reviews: [],
  readyToDownload: false,
  online: true,
  discarded: false,
  canvasSize: null,
};
export const userSlice = createSlice({
  name: "userSlice",
  initialState: initState,
  reducers: {
    setUserAuth: (state, action) => {
      state.user_Auth = action.payload;
    },
    setUserVerify: (state, action) => {
      state.user_Verify = action.payload;
      state.loader = false;
    },
    setTemplate: (state, action) => {
      state.template = action.payload;
    },
    setID: (state, action) => {
      state.current_TemplateID = action.payload;
    },
    setBatchImages: (state, action) => {
      state.batchImages = action.payload;
    },
    setCanvasSize: (state, action) => {
      state.canvasSize = action.payload;
    },
    setReviews: (state, action) => {
      state.reviews = action.payload;
    },
    setTemplate_Edit: (state, action) => {
      state.template_Edit = action.payload;
    },
    setEdit_Template: (state, action) => {
      state.edit_Template = action.payload;
    },
    setCreate_Template: (state, action) => {
      state.create_Template = action.payload;
    },
    setTemplate_Changed: (state, action) => {
      state.templateChanged = action.payload;
    },
    setOnline: (state, action) => {
      state.online = action.payload;
    },
    setBatchDownload: (state, action) => {
      state.batchDownload = action.payload;
      state.readyToDownload = !action.payload;
    },
    setDiscarded: (state, action) => {
      state.discarded = action.payload;
    },
    ClearUser: () => {
      return { ...initState };
    },
    ClearCache: (state) => {
      return {
        ...state,
        loader: false,
        template_Edit: false,
        edit_Template: false,
        create_Template: false,
        templateChanged: false,
        batchDownload: false,
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setUserAuth,
  setUserVerify,
  setTemplate,
  setID,
  setBatchImages,
  setTemplate_Edit,
  setTemplate_Changed,
  setEdit_Template,
  setCreate_Template,
  setBatchDownload,
  ClearUser,
  setReviews,
  ClearCache,
  setOnline,
  setCanvasSize,
  setDiscarded,
} = userSlice.actions;

export default userSlice.reducer;
